// import "./style.css";
// import "./animation.css";
import raindrop from "./rain.url.svg";
import breeze from "./wind.raw.svg";

declare global {
  interface Window {
    sensor: {
      windStart: (evt: PointerEvent) => {
        startTime: number;
        startX: number;
        startY: number;
      };
      windEnd: (
        evt: PointerEvent,
      ) => { endTime: number; endX: number; endY: number } | undefined;
      rainClick: () => void;
    };
  }
}

let windStarted = false;
let windStartX = 0;
let windStartY = 0;
let windEndX = 0;
let windEndY = 0;

const windButton = document.querySelector<HTMLDivElement>("#wind");
function windStart(evt: PointerEvent) {
  windStartX = evt.clientX;
  windStartY = evt.clientY;

  windStarted = true;
  return { startTime: Date.now(), startX: windStartX, startY: windStartY };
}

function windEnd(evt: PointerEvent) {
  if (!windStarted) return;
  windStarted = false;
  const rect = windButton?.getBoundingClientRect();
  if (!rect) return;

  windEndX = evt.clientX;
  windEndY = evt.clientY;

  const MIN_SWIPE_DISTANCE = 10;
  const distance = Math.sqrt(
    (windEndX - windStartX) ** 2 + (windEndY - windStartY) ** 2,
  );
  if (distance < MIN_SWIPE_DISTANCE) return undefined;

  const wind = document.createElement("div");
  wind.innerHTML = breeze;
  wind.style.visibility = "hidden";
  const swipeAngle =
    Math.atan2(windEndY - windStartY, windEndX - windStartX) + Math.PI / 4;
  wind.style.setProperty("--x", `${windStartX - rect.left}px`);
  wind.style.setProperty("--y", `${windStartY - rect.top - rect.height}px`);
  wind.style.setProperty("--width", `${rect.height * 1.2}px`);
  wind.style.setProperty("--swipe", `${swipeAngle}rad`);
  wind.addEventListener("animationend", () => {
    wind.remove();
  });

  windButton?.appendChild(wind);
  wind.style.visibility = "";

  return { endTime: Date.now(), endX: windEndX, endY: windEndY };
}

// document.addEventListener("mouseup", windEnd);
// document.addEventListener("touchend", windEnd);

document.addEventListener("pointercancel", () => {
  windStarted = false;
});

const rainButton = document.querySelector<HTMLDivElement>("#rain")!;

function rainClick() {
  const buttonWidth = rainButton.offsetWidth;
  const buttonHeight = rainButton.offsetHeight * 2;
  const raindropHeight = Math.max(Math.round(Math.random() * 30), 14);
  const raindropX =
    Math.round(Math.random() * buttonWidth * 0.9) +
    Math.round(buttonWidth * 0.05);
  const drop = document.createElement("img");
  drop.src = raindrop;
  drop.classList.add("raindrop");
  drop.classList.add("raining");
  drop.style.setProperty("height", `${raindropHeight}px`);
  drop.style.setProperty("--x", `${raindropX}px`);
  drop.style.setProperty("--y", `${buttonHeight}px`);
  document.querySelector<HTMLDivElement>("#rain")?.appendChild(drop);
}

window.sensor = { windStart, windEnd, rainClick };

rainButton?.addEventListener("animationend", (ev) => {
  const element = ev.target as HTMLElement;
  if (element?.classList.contains("raindrop")) {
    element.remove();
  }
});
